import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "item"]

  connect() {
    const showCompleted = localStorage.getItem("projectsShowCompleted") === "true"
    if (showCompleted) {
      this.show()
    }
  }

  toggle() {
    const isHidden = this.itemTargets[0]?.classList.contains("hidden")
    if (isHidden) {
      this.show()
    } else {
      this.hide()
    }
  }

  show() {
    this.itemTargets.forEach(item => item.classList.remove("hidden"))
    if (this.hasButtonTarget) {
      this.buttonTarget.textContent = "Hide completed"
    }
    localStorage.setItem("projectsShowCompleted", "true")
  }

  hide() {
    this.itemTargets.forEach(item => item.classList.add("hidden"))
    if (this.hasButtonTarget) {
      const count = this.itemTargets.length
      this.buttonTarget.textContent = `Show ${count} completed project${count === 1 ? '' : 's'}`
    }
    localStorage.setItem("projectsShowCompleted", "false")
  }
}
